module.exports = __webpack_public_path__ + "img/internupload.1c9eda2a.svg";